module.exports = __webpack_public_path__ + "static/media/failed.d6fc5a85.svg";